import axios from "axios";

export interface AuthApiError {
  errorKey: string | null;
  title: string;
  message: string;
}

export const formatErrorKey = (errorKey: string) =>
  errorKey
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const getAuthApiError = (
  err: unknown,
  fallbackTitle: string,
  fallbackMessage: string
): AuthApiError => {
  if (axios.isAxiosError(err) && err.response) {
    const data = err.response.data || {};
    const errorKey =
      typeof data.error_key === "string" && data.error_key.trim()
        ? data.error_key.trim()
        : null;
    const message =
      (typeof data.error === "string" && data.error) ||
      (typeof data.message === "string" && data.message) ||
      fallbackMessage;

    return {
      errorKey,
      title: errorKey ? formatErrorKey(errorKey) : fallbackTitle,
      message,
    };
  }

  return {
    errorKey: null,
    title: "Network Error",
    message: "Unable to reach the server. Check your connection and try again.",
  };
};
